import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";
import { toJalaali } from "jalaali-js";
// import im12 from "assets/image/slider/2.jpg";
// import im11 from "assets/image/slider/3.jpg";
// import im10 from "assets/image/slider/4.jpg";
// import im9 from "assets/image/slider/5.jpg";
// import im8 from "assets/image/slider/6.jpg";
// import im7 from "assets/image/slider/7.jpg";
// import im6 from "assets/image/slider/8.jpg";
// import im5 from "assets/image/slider/9.jpg";
// import im4 from "assets/image/slider/13.jpg";
// import im3 from "assets/image/slider/11.jpg";
// import im2 from "assets/image/slider/12.jpg";
// import im1 from "assets/image/slider/1.jpg";

import img1 from "../assets/image/slider2/1-007.jpg"
import img2 from "../assets/image/slider2/1-008.jpg"
import img3 from "../assets/image/slider2/1-009.jpg"
import img4 from "../assets/image/slider2/1-010.jpg"

import topPic from "../assets/image/Layer 15.png";

import Top from "./Top";
import Menu from "./Menu";
import TourCarousel from "./TourCarousel";
import Loader from "utilities/Loader";

import { getInfo } from "../services/home";
import "./homec.css";
import "./home.scss";
import image from "../assets/image/jomesob.jpg";
import { connection } from "services/services";

export default function Home() {
  const texts = [
    "سفر یعنی زنده بودن.",
    "زمان کم و دنیا گسترده است.",
    "هر سفر دنیایی از ناشناخته ها در خودش دارد که مسافران از آن بی خبر اند.",
  ];

  const [theTours, setTheTours] = useState([
    {
      type: { id: -1, title: "تور ویژه" },
      tourList: [],
    },
  ]);
  const [specialTours, setSpecialTours] = useState([]);
  const [loading, setLoading] = useState(true);

  const settingTours = (data, theTags) => {
    let tours = [{ type: { id: 0, title: "همه" }, tourList: [] }],
      theSpecialTours = [];
    theTags.forEach((value) => {
      tours.push({
        type: { id: value.id, title: value.title },
        tourList: [],
      });
    });
    let typeIndex = [];
    data.forEach((value) => {
      typeIndex = [0];
      value.tags.forEach((tag) => {
        if (tag.ismain == 1) {
          tours.forEach((val, index) => {
            if (val.type.id == tag.id) {
              typeIndex.push(index);
              return true;
            }
            return false;
          });
        }
      });
      let city = value.city.length > 0 ? value.city[0].title : "";
      let record = {
        id: value.id,
        title: value.title,
        city,
        image:
          value.cover_pic == ""
            ? image
            : `http://mvc.dade24.ir/${value.cover_pic}`,
        start_time: "",
        duration: "",
        end_time: "",
        max_participant:
          parseInt(value.public_capacity) -
          parseInt(value.frozen_reserved) -
          parseInt(value.complate_reserved),
        price: value.mainprice,
        essentials: value.essentials_accessories.replaceAll("+", "، "),
      };
      try {
        let start_time = toJalaali(new Date(value.stm * 1000)),
          end_time = toJalaali(new Date(value.ftm * 1000)),
          duration = parseInt(value.ftm) - parseInt(value.stm);
        record.start_time = `${start_time.jy}/${
          start_time.jm - 1 > 9 ? start_time.jm - 1 : "0" + (start_time.jm - 1)
        }/${start_time.jd > 9 ? start_time.jd : "0" + start_time.jd}`;
        record.end_time = `${end_time.jy}/${
          end_time.jm - 1 > 9 ? end_time.jm - 1 : "0" + (end_time.jm - 1)
        }/${end_time.jd > 9 ? end_time.jd : "0" + end_time.jd}`;
        record.duration = Math.ceil(duration / 86400);
      } catch (err) {}
      [...new Set(typeIndex)].forEach((index) => {
        tours[index].tourList.push(record);
      });
      console.log("value :>> ", value);
      if (value.isspecial == 1) {
        theSpecialTours.push(record);
      }
    });
    // console.log("theSpecialTours :>> ", theSpecialTours);
    setTheTours(tours);
    setSpecialTours(theSpecialTours);
  };

  useEffect(() => {
    async function loadPage() {
      let res = await getInfo();
      settingTours(res.data, res.tags);
      setLoading(false);
    }
    loadPage();
  }, []);

  SwiperCore.use([Autoplay]);

  return (
    <>
      <div className="the-home home-container">
        {/* <!--flight card--> */}
        {/* <img style={{ width: "  100%" }} src={topPic}></img> */}
        <div>
          <div
            id="carouselExampleInterval"
            class="carousel slide "
            data-bs-ride="carousel"
          >
            <div class="carousel-inner slideHight">
              <div
                class="carousel-item active w-100 h-100"
                data-bs-interval="10000"
              >
                <img src={img1} class="d-block w-100 imgHeight" alt="..." />
              </div>
              {/* <div
                class="carousel-item active w-100 h-100"
                data-bs-interval="10000"
              >
                <img src={im5} class="d-block w-100 imgHeight" alt="..." />
              </div>
              <div class="carousel-item w-100 h-100" data-bs-interval="2000">
                <img src={im1} class="d-block w-100 imgHeight" alt="..." />
              </div> */}
              {/* {[im2, im4, im3, im6, im7, im8, im9, im10, im11, im12].map( */}
              {[img2, img3, img4,].map(
                (value) => (
                  <div class="carousel-item w-100 h-100">
                    <img
                      src={value}
                      class="d-block w-100 imgHeight"
                      alt="..."
                    />
                  </div>
                )
              )}
              {/* <div class="carousel-item w-100 h-100">
                <img src={im4} class="d-block w-100 imgHeight" alt="..." />
              </div>
              <div class="carousel-item w-100 h-100">
                <img src={im3} class="d-block w-100 imgHeight" alt="..." />
              </div>
              <div class="carousel-item w-100 h-100">
                <img src={im6} class="d-block w-100 imgHeight" alt="..." />
              </div>
              <div class="carousel-item w-100 h-100">
                <img src={im7} class="d-block w-100 imgHeight" alt="..." />
              </div>
              <div class="carousel-item w-100 h-100">
                <img src={im8} class="d-block w-100 imgHeight" alt="..." />
              </div>
              <div class="carousel-item w-100 h-100">
                <img src={im9} class="d-block w-100 imgHeight" alt="..." />
              </div>
              <div class="carousel-item w-100 h-100">
                <img src={im10} class="d-block w-100 imgHeight" alt="..." />
              </div>
              <div class="carousel-item w-100 h-100">
                <img src={im11} class="d-block w-100  imgHeight" alt="..." />
              </div>
              <div class="carousel-item w-100 h-100">
                <img src={im12} class="d-block w-100 imgHeight" alt="..." />
              </div> */}
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleInterval"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleInterval"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        {/* <Top /> */}
        <Menu />
        {/* دسته بندی تور ها */}
        {theTours.length > 0 ? (
          <>
            {loading ? <Loader /> : ""}

            <div className="container mt-4">
              <div className="fw-bolder fs-4 text-color">دسته بندی تورها</div>
              <ul
                className="nav nav-tabs "
                style={{ marginBottom: "2rem" }}
                id="tour-tab"
                role="tablist"
              >
                {theTours.map((value, index) => (
                  <li className="nav-item" role="presentation" key={index}>
                    <button
                      className={`tour nav-link text-dark font-regular ${
                        index === 0 ? "active" : ""
                      }`}
                      id={`tab-${value.type.id}`}
                      data-bs-toggle="tab"
                      data-bs-target={`#content-${value.type.id}`}
                      type="button"
                      role="tab"
                      aria-controls={`content-${value.type.id}`}
                      aria-selected="false"
                    >
                      {value.type.title}
                    </button>
                  </li>
                ))}
              </ul>
              {/* <!-- content tab tour--> */}
              <div className="tab-content" id="tabContent1">
                {/* <!--tab tour iran--> */}
                {theTours.map((value, index) => (
                  <div
                    className={`tab-pane fade ${
                      index === 0 ? "show active" : ""
                    } container`}
                    id={`content-${index}`}
                    // id={`content-${value.type.id}`}
                    role="tabpanel"
                    aria-labelledby={`tab-${index}`}
                    // aria-labelledby={`tab-${value.type.id}`}
                    key={index}
                  >
                    <TourCarousel
                      key={`tours-${index}`}
                      id={`tours-${index}`}
                      tours={value.tourList}
                    />
                    <div
                      id={`tours-${index}-swiper-button-prev`}
                      class={`swiper-button-next d-none ${
                        value.tourList.length > 4
                          ? "d-xl-flex"
                          : value.tourList.length > 3
                          ? "d-lg-flex d-xl-none"
                          : ""
                      }`}
                    ></div>
                    <div
                      id={`tours-${index}-swiper-button-next`}
                      class={`swiper-button-prev d-none ${
                        value.tourList.length > 4
                          ? "d-xl-flex"
                          : value.tourList.length > 3
                          ? "d-lg-flex d-xl-none"
                          : ""
                      }`}
                    ></div>
                  </div>
                ))}
              </div>
            </div>

            {specialTours.length > 0 ? (
              <>
                {/* تور ویژه */}
                <div id="content-special" className="container mt-4">
                  <div
                    className="fw-bolder fs-4 text-color"
                    style={{ marginBottom: "2rem" }}
                  >
                    تور های ویژه
                  </div>
                  <TourCarousel
                    key={`special-tours`}
                    id={`tours-special`}
                    tours={specialTours}
                  />
                  <div
                    id={`tours-special-swiper-button-prev`}
                    class={`swiper-button-next d-none ${
                      specialTours.length > 4
                        ? "d-xl-flex"
                        : specialTours.length > 3
                        ? "d-lg-flex d-xl-none"
                        : ""
                    }`}
                  ></div>
                  <div
                    id={`tours-special-swiper-button-next`}
                    class={`swiper-button-prev d-none ${
                      specialTours.length > 4
                        ? "d-xl-flex"
                        : specialTours.length > 3
                        ? "d-lg-flex d-xl-none"
                        : ""
                    }`}
                  ></div>
                </div>
              </>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}

        {/* <div className="d-flex justify-content-end">
          <Swiper
            spaceBetween={50}
            slidesPerView={1}
            loop
            autoplay={{
              delay: 3500,
              pauseOnMouseEnter: false,
            }}
          >
            {texts.map((txt, index) => (
              <SwiperSlide>
                <div className="text-end pe-5 mt-3" key={index}>
                  {txt}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div> */}
      </div>
    </>
  );
}
